import { Component, inject, Input, OnInit } from '@angular/core';
import { AppService, AuthenticationService } from '@lc/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { map, switchMap, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { CookieService } from '@lc/core/lib/services/cookie.service';

@Component({
  selector: 'lc-app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  imports: [MatButton, AsyncPipe],
})
export class LogoutComponent implements OnInit {
  authService = inject(AuthenticationService);
  private activatedRoute = inject(ActivatedRoute);
  private titleService = inject(Title);
  private readonly cookieService = inject(CookieService);

  @Input() title: string;
  readonly appName: string = this.cookieService.getCookie('app') || AppService.get('applicationName');
  isForcedLogout: boolean = false;
  isLoggedOut$: Observable<boolean>;

  constructor() {
    this.isLoggedOut$ = this.activatedRoute.queryParamMap.pipe(
      tap((params) => (this.isForcedLogout = !!params.get('forcedLogout'))),
      switchMap(async () => await this.authService.logout()),
      map(() => true),
    );
  }

  ngOnInit() {
    this.titleService.setTitle(`${this.titleService.getTitle()} - Logout`);
  }

  login() {
    this.authService.redirectToLogin();
  }
}
